export default function(app){
	app.directive('frameset',{
		inserted(el){
			// 当嵌入web时，不显示nav-bar
			// #ifdef H5
			if(top!==self) el.remove();
			// #endif
		}
	})
}